import React from 'react'
import styled from 'styled-components'
import IcShare from './images/ic-share.component.svg'

const ShareButtonV2 = ({ className, onClick, title, ...props }) => {
  const handleClick = () => {
    onClick && onClick()
  }

  return (
    <Wrapper className={className} onClick={handleClick} {...props}>
      <IcShare />
      {title}
    </Wrapper>
  )
}

export default ShareButtonV2

const Wrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: none;
  outline: none;
  cursor: pointer;

  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */

  &:hover {
    text-decoration: underline;
  }
`



// WEBPACK FOOTER //
// ./src/components/ShareButtonV2/index.js